import SETTINGS from 'constants/settings';
import extractLineNumberFromSku from 'utils/extract-linenumber-from-sku';

const generateImageSrc = itemId =>
  `${SETTINGS.productImage}/3/LN_${extractLineNumberFromSku(itemId)}_BP_3.jpg`;

export default generateImageSrc;
